import Header from './Header'
import './Header.css'
import './background.css'

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js